// i18n area 'system' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.nl-NL.meta.json.
import type { enUS } from './system'

export const nlNL: typeof enUS = {
  diagnostics: {
    title: 'Diagnose',
    subtitle: 'Wat er mis is, het ergste eerst — dezelfde lens als tvirt diagnose',
    reload: 'Herladen',
    loadError: 'De diagnose kon niet worden gelezen',
    exportBundle: 'Bundel exporteren',
    exportError: 'De bundel kon niet worden aangemaakt',
    noProblem: 'Geen probleem in de geïnspecteerde gebieden',
    nothingInspected: 'NIETS is geïnspecteerd — dit is geen bewijs van goede gezondheid',
    inspected: 'Geïnspecteerd',
    notInspected: 'NIET geïnspecteerd',
    localHint: 'De node-lokale gebieden (systemd-units, journal) zijn alleen via de CLI leesbaar: tvirt diagnose --area local — de weg wanneer de API niet antwoordt.',
    thresholds: 'mislukte taken binnen {hours} u, heartbeat later dan {seconds} s',
    severity: {
      critical: 'Kritiek',
      warning: 'Waarschuwing',
      unknown: 'Onbekend'
    }
  },
  explorer: {
    title: 'Resources verkennen',
    root: 'Root',
    empty: 'Geen resources in deze scope',
    previewHint: 'Selecteer een object om het voorbeeld ervan te zien',
    open: 'Openen',

    // De deep-link ?scope= van de CRUD-lijsten (ronde #109), vanuit het verkennen (#143).
    openScoped: 'De lijst in deze scope openen',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM-template',
      ct: 'CT',
      ctTemplate: 'CT-template',
      app: 'App',
      overlayNetwork: 'Overlaynetwerk',
      networkService: 'Netwerkdienst',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Storage-pool',
      disk: 'Schijf',
      catalogFile: 'Catalogusbestand',
      ociRegistry: 'OCI-registry',
      ociImage: 'OCI-image',
      cephCluster: 'Ceph-cluster',
      backupDestination: 'Backupbestemming',
      user: 'Gebruiker',
      group: 'Groep',
      role: 'Rol',
      credential: 'Credential',
      tag: 'Tag',
      proximityRule: 'Proximity-regel'
    }
  },
  tags: {
    title: 'Tags',
    empty: 'Geen tags',
    add: 'Tag toevoegen',
    remove: 'Weghalen',
    name: 'Tag',
    value: 'Waarde',
    save: 'Opslaan',
    saveError: 'De tags konden niet worden opgeslagen',
    loadError: 'De woordenlijst met tags kon niet worden geladen',
    noVocabulary: 'Geen tag beschikbaar voor dit type resource',

    // Een tag met één waarde die al gezet is antwoordt 409: de vervanging is altijd
    // expliciet — nooit een impliciete substitutie (design, geratificeerd 2026-07-27).
    overwrite: 'De huidige waarde vervangen',

    // Systeem > Tags, het oppervlak van de woordenlijst.
    createTitle: 'Tag aanmaken',
    editTitle: 'Tag bewerken',
    nameHint: 'Letters, cijfers, punten, koppeltekens en underscores — geen ":" of "/"; het voorvoegsel tvirt- is voor het platform gereserveerd',
    cardinality: 'Kardinaliteit',
    cardinalitySingle: 'Eén enkele waarde',
    cardinalityMultiple: 'Meerdere waarden',
    cardinalityHint: 'Bij één enkele waarde vraagt het opnieuw toekennen van de tag om vervanging',
    autoCreate: 'Waarden automatisch aanmaken',
    autoCreateOn: 'Bij toekenning',
    autoCreateOff: 'Alleen gedeclareerde',
    autoCreateHint: 'Aan: een nieuwe waarde toekennen maakt hem aan. Uit: alleen gedeclareerde waarden zijn toe te kennen',
    values: 'Waarden',
    noValues: 'Geen waarde gedeclareerd',
    addValue: 'Waarde toevoegen',
    duplicateValue: 'Dubbele waarde',
    kinds: 'Resourcetypen',
    kindsAll: 'Alle',
    kindsPlaceholder: 'Alle',
    kindsHint: 'Laat leeg om elk type resource toe te laten dat getagd kan worden',
    systemChip: 'Systeem',
    deleteCascade: 'Ook de toewijzingen verwijderen',
    deleteCascadeHint: 'Een tag die nog aan een resource is toegewezen, wordt geweigerd: met deze optie verdwijnen de waarden en alle toewijzingen samen met de tag.'
  },
  scopes: {
    title: 'Scopes',
    createTitle: 'Scope aanmaken',
    editTitle: 'Scope hernoemen',
    path: 'Pad',
    segment: 'Segment',
    segmentHint: 'Kleine letters, cijfers en koppeltekens (DNS-1123)',
    parent: 'Parent',
    rootChip: 'Root',
    preview: 'Nieuwe scope',
    pickLabel: 'Scope',
    pickHint: 'Waar het object in de boom van het cluster leeft — de root of een vDC daarbinnen.',
    ociCache: 'OCI-cache (override)',
    appEphemeral: 'Vluchtige pools van Apps (override)',
    inherit: 'Overerven',
    inheritsFrom: 'Erft van',
    inheritsCluster: 'Erft de cluster-default',
    inheritsNone: 'Erft — geen effectieve pool',
    failoverProtection: 'Bescherming in gedegradeerd cluster',
    networkWeight: 'Netwerkgewicht',
    networkCeil: 'Netwerkplafond (Mbps)',
    protectionProtected: 'Beschermd',
    protectionExpendable: 'Opofferbaar bij degradatie',
    protectionDefault: 'Clusterstandaard'
  },

  // Systeem > Informatie (ronde #124, 2026-07-31): platformversies in de
  // fleet (hoogstens twee tijdens een upgrade), componenten per node,
  // lokaal geserveerde PDF-handleiding en ingesloten licentiecard.
  sysinfo: {
    summary: 'Versies van het platform in het cluster, componenten van elke node, beheerhandleiding en licentie.',
    platformTitle: 'TVirt-platform',
    platformSubtitle: 'Versies waargenomen op de nodes van het cluster',
    versionOnNodes: '{version} op {n} nodes',
    versionOnOneNode: '{version} op 1 node',
    mixedVersions: 'Meer dan één versie van het platform in het cluster — alleen te verwachten tijdens een lopende upgrade (hoogstens twee).',
    tooManyVersions: 'Meer dan twee versies van het platform in het cluster — dat is nooit te verwachten, ook niet tijdens een upgrade: controleer de nodes hieronder.',
    unreportedNodes: 'Nog geen versierapport van: {nodes}',
    noVersionsYet: 'Nog geen enkele node heeft zijn versies gemeld.',
    nodesUnavailable: 'De lijst met nodes is met jouw rechten niet zichtbaar — de versies van het platform kunnen niet worden getoond.',
    colNode: 'Node',
    manualTitle: 'Beheerhandleiding',
    manualSubtitle: 'Lokale kopie, geserveerd door dit cluster',
    manualBody: 'De volledige TVirt-handleiding in PDF, rechtstreeks door het platform geserveerd — ook beschikbaar in air-gapped omgevingen.',
    manualLink: 'Beheerhandleiding (PDF)',
    apiExplorerTitle: 'API-verkenner',
    apiExplorerSubtitle: 'Het OpenAPI-contract, doorbladerbaar',
    apiExplorerBody: 'Het volledige OpenAPI-contract van het platform — elke route, elk schema en elke responscode — te verkennen vanuit de browser, geserveerd via deze node.',
    apiExplorerLink: 'API verkennen',
    kubeTitle: 'Kubernetes-compatibiliteit',
    kubeSubtitle: 'kubectl en zijn tools, vóór de native API',
    kubeBody: 'TVirt KubeCompat projecteert Pods, Deployments, Services, namespaces, nodes en gebeurtenissen in het Kubernetes-dialect — alleen-lezen, plus het verwijderen van Deployments. Elke aanroep loopt via de native API met jouw rechten: gebruik in de kubeconfig een app-token als bearer.',
    kubeEndpoint: 'Endpoint voor kubectl',
    kubeStatusActive: 'Actief — Kubernetes {version}',
    kubeStatusMissing: 'Niet geïnstalleerd op deze node (pakket trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Geïnstalleerd maar antwoordt niet — controleer de unit trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Controleren…'
  },

  // Licensing (ronde 2026-07-29): de pagina van de abonnementslicentie.
  licensing: {
    title: 'Licentie van het cluster',
    subtitle: 'Abonnementslicentie — hoogstens één per cluster',
    absentTitle: 'Geen licentie geregistreerd',
    absentBody:
      "Zonder geldige licentie weigert het cluster nieuwe virtuele machines te starten (draaiende VM's blijven draaien). Registreer de productsleutel die je bij het abonnement hebt gekregen.",
    registerButton: 'Licentie registreren',
    removeButton: 'Licentie weghalen',
    state: {
      ok: 'Geldig',
      limitExceeded: 'Limiet overschreden',
      expired: 'Verlopen'
    },
    productKeyLabel: 'Productsleutel',
    basisLabel: 'Grondslag van de limiet',
    basis: {
      concurrentVms: "Gelijktijdig draaiende VM's",
      physicalCores: 'Fysieke cores (clustertotaal)'
    },
    limitLabel: 'Limiet',
    usageLabel: 'Huidig gebruik',
    usageOf: '{used} van {limit}',
    usagePartial: 'gedeeltelijke som — {n} node(s) zonder waargenomen CPU-topologie',
    usageUnknown: 'op dit moment niet waarneembaar',
    expiresLabel: 'Vervaldatum',
    neverExpires: 'nooit',
    registeredLabel: 'Geregistreerd',
    gateNote:
      "Bij een ontbrekende, verlopen of overschreden licentie weigert het cluster NIEUWE virtuele machines te starten. Draaiende VM's blijven draaien en de HA-herstarts hebben er geen last van.",
    devStage:
      'Ontwikkelfase: de productsleutel wordt aanvaard zoals hij is, samen met de hier gedeclareerde limieten; de validatie met een ondertekende sleutel komt in een toekomstige release.',
    dialogTitle: 'Licentie registreren',
    dialogExpiresHelp: 'Leeg = de licentie verloopt nooit',
    dialogSubmit: 'Registreren',
    dialogError: 'De licentie kon niet worden geregistreerd.',
    removeTitle: 'Licentie weghalen',
    removeBody:
      "Het cluster blijft ZONDER LICENTIE achter: nieuwe virtuele machines weigeren te starten totdat je er een registreert. Draaiende VM's blijven draaien.",
    removeConfirm: 'Weghalen',
    removeError: 'De licentie kon niet worden weggehaald.'
  },
  rbac: {
    tabRoles: 'Rollen',
    tabGrants: 'Delegaties',
    rolesTitle: 'Rollen',
    createRoleTitle: 'Rol aanmaken',
    editRoleTitle: 'Rol bewerken',
    nameHint: 'Kleine letters, cijfers en koppeltekens; het voorvoegsel tvirt- is gereserveerd',
    systemChip: 'Systeem',
    permissions: 'Rechten',
    permissionsPlaceholder: 'Recht toevoegen…',
    includedRoles: 'Inbegrepen rollen',
    includedRolesPlaceholder: 'Rol toevoegen…',
    grantsTitle: 'Delegaties',
    createGrantTitle: 'Delegatie aanmaken',
    principal: 'Principal',
    principalKind: 'Type principal',
    principalUser: 'Gebruiker',
    principalGroup: 'Groep',
    role: 'Rol',
    grantRight: 'Delegatie',
    grantRightChip: 'Mag delegeren',
    grantRightLabel: 'Met delegatierecht (de ontvanger mag deze rol op zijn beurt delegeren)',
    effective: 'Effectief',
    notEffective: 'Niet effectief',
    createdAt: 'Aangemaakt',
    scopeHint: '/path exact, /path/* recursief — delegaties ankeren aan een gemonteerde root (/* is niet te delegeren)'
  },
  groups: {
    title: 'Groepen',
    createTitle: 'Groep aanmaken',
    nameHint: 'Kleine letters, cijfers en koppeltekens; uniek binnen de scope',
    members: 'Leden',
    membersTitle: 'Leden',
    membersPlaceholder: 'Gebruiker toevoegen…',
    noMembers: 'Geen leden',
    realmMappings: 'Realm-mappings',
    realmMappingsTitle: 'Realm-mappings',
    realmMappingsHint:
      'Waarmee deze groep in elk extern realm overeenkomt. Het lidmaatschap wordt bij het inloggen uit de directory gelezen: een directorygroep die hier door niemand wordt gemapt, wordt genegeerd, en nesting wordt niet opgelost — vlak die af aan de kant van de directory.',
    realm: 'Realm',
    externalGroup: 'Externe groep',
    addRealmMapping: 'Mapping toevoegen',
    removeRealmMapping: 'Mapping weghalen',
    noRealmMappings: 'Geen realm-mappings',

    // Aanmaakdialoog met secties (ronde realm-wizard, 2026-08-03): Algemeen
    // plus het mappingoppervlak met de externe realms, met de sprekende
    // empty state.
    sectionGeneral: 'Algemeen',
    mappingsNoRealms: 'Nog geen extern realm geconfigureerd — het mappingoppervlak gaat open zodra er een realm bestaat.',
    mappingsNoRealmsLink: 'Open het tabblad Realms en SSO',

    // De door de groep opgelegde MFA-verplichting (ronde #178, helft B): een
    // pure OR — een groep kan de verplichting alleen TOEVOEGEN, nooit opheffen.
    mfaRequired: 'MFA-verplichting',
    mfaRequiredChip: 'Legt MFA op',
    mfaNotRequiredChip: 'Geen verplichting',
    mfaRequiredHint:
      'Een pure OR: een groep kan de verplichting van de tweede factor TOEVOEGEN voor haar leden — ook voor externe identiteiten, via de realm-mappings — nooit opheffen. Ze geldt vanaf de volgende keer inloggen: open sessies worden niet gesloten.'
  },
  users: {
    title: 'Gebruikers',
    createTitle: 'Gebruiker aanmaken',
    editTitle: 'Gebruiker bewerken',
    username: 'Gebruikersnaam',
    usernameHint: 'Kleine letters, cijfers, punten en koppeltekens',
    displayName: 'Weergavenaam',
    enabled: 'Ingeschakeld',
    state: 'Status',
    enabledChip: 'Ingeschakeld',
    disabledChip: 'Uitgeschakeld',
    lockedChip: 'Geblokkeerd',
    password: 'Wachtwoord',
    passwordSetChip: 'Ingesteld',
    mustChangeChip: 'Moet gewijzigd worden',
    initialPassword: 'Initieel wachtwoord',
    initialPasswordHint: 'De gebruiker moet het bij de eerste keer inloggen wijzigen',
    lastLogin: 'Laatste keer ingelogd',
    neverLoggedIn: 'Nooit ingelogd',
    setPasswordTitle: 'Wachtwoord instellen',
    setPasswordHint: 'Administratieve vervanging — vereist jouw wachtwoord (sudo-modus) en verplicht de gebruiker het bij de volgende keer inloggen te wijzigen.',
    operatorPassword: 'Jouw wachtwoord',
    unlock: 'Account deblokkeren',
    revokeTitle: 'Sessies intrekken',
    revokeBody: 'Alle actieve sessies van deze gebruiker worden onmiddellijk beëindigd.',
    revokeIncludeTokens: 'Ook de app tokens intrekken',
    revokeConfirm: 'Intrekken',

    // Standaarddialoog (ronde #156): volledige details, tabbladen account/beveiliging.
    tabAccount: 'Account',
    tabSecurity: 'Beveiliging',
    usernameImmutableHint: 'De gebruikersnaam is de identiteit van het account — vastgelegd bij het aanmaken',
    groups: 'Groepen',
    noGroups: 'Geen groepen',
    mustChangePassword: 'Wachtwoordwijziging verplicht',
    failedAttempts: 'Mislukte inlogpogingen',
    lockedUntil: 'Geblokkeerd tot',

    // Identity-tabbladen (2026-08-03): Systeem > Gebruikers is een sectie met
    // tabbladen geworden naar het model van /system/rbac — gebruikers, groepen,
    // externe realms.
    tabUsers: 'Gebruikers',
    tabGroups: 'Groepen',
    tabRealms: 'Realms en SSO',
    tabMfa: 'MFA',

    // Tabblad MFA (task #178, helft A — GUI op het bestaande contract): de
    // weergave per gebruiker van de tweede factor. De enrollments van externe
    // identiteiten en de verweesde status zijn helft B — contractronde, nooit
    // een formulier zonder backend.
    mfa: {
      title: 'Tweede factor (MFA)',
      methodsTitle: 'Beschikbare methoden',
      methodsSubtitle: 'Wat deze installatie als tweede factor kan verifiëren',
      methodsError: 'Het register met methoden kon niet worden geladen',
      builtinChip: 'Ingebouwd',
      enrollableChip: 'Enrollment in TVirt',
      delegatedChip: 'Extern beheerd',
      state: 'Status',
      stateActive: 'Actief',
      statePending: 'Wacht op enrollment',
      stateNone: 'Niet ingeschreven',
      required: 'MFA-verplichting',
      requiredChip: 'Verplicht',
      notRequiredChip: 'Niet verplicht',
      enrolledAt: 'Enrollment van',
      enrolledMethods: 'Ingeschreven methoden',
      noMethods: 'Geen enrollment',
      codesRemaining: 'Resterende herstelcodes',
      resetTitle: 'De tweede factor resetten',
      resetHint:
        'Het enrollment en alle herstelcodes worden gewist: bij de volgende keer inloggen doet de gebruiker het enrollment helemaal opnieuw. De MFA-verplichting blijft zoals hij is — een beheerder stelt nooit een geheim in, hij wist het alleen.',
      resetConfirm: 'Resetten',
      resetError: 'De tweede factor kon niet worden gereset',
      empty: 'Nog geen beheerde gebruikers — accounts verschijnen hier zodra ze bestaan, elk met zijn status van de tweede factor.',

      // Helft B (ronde #178): herkomst van het geldende verdict, externe
      // enrollments met de verweesd-status, groepen die de verplichting opleggen.
      viaSelf: 'Persoonlijk',
      viaSelfHint: 'De persoonlijke bijdrage van het account (zijn vlag) — het enige deel dat het potlood bewerkt.',
      viaGroupHint: 'Verplichting geërfd van deze groep: de persoonlijke vlag weghalen bevrijdt de gebruiker niet — je grijpt in op de groep, in het tabblad Groepen.',
      subject: 'Identiteit',
      lastSeenAt: 'Laatst bevestigd',
      enrollmentPending: 'In afwachting',
      orphanChip: 'Verweesd',
      orphanDirectoryMiss: 'De identiteit staat niet meer in de directory',
      orphanRealmRemoved: 'Het realm is uit TVirt verwijderd',
      orphanedAt: 'Verweesd sinds',
      directoryUuid: 'UUID in de directory',
      externalTitle: 'Externe enrollments',
      externalEmpty: 'Nog geen extern enrollment — het ontstaat bij de eerste keer inloggen van een directory-identiteit met MFA-verplichting.',
      orphanHelp:
        'Een verweesd enrollment wist zichzelf nooit: het is beveiligingsmateriaal — het blijft voor de audit, en duikt de identiteit weer op in de directory, dan vindt ze haar factor terug. De enige uitweg is de administratieve reset.',
      visibilityHint: 'Externe enrollments wonen in de root van het cluster: alleen wie user.read over de hele boom heeft, ziet ze.',
      orphanResetHint:
        'De verweesde rij wordt definitief verwijderd: niemand maakt er nog aanspraak op. Duikt de identiteit weer op in de directory, dan doet ze het enrollment helemaal opnieuw.',
      enforcingTitle: 'Groepen die MFA opleggen',
      enforcingSubtitle:
        'Het anker van de verplichting voor externe identiteiten is de groep: zijn realm-mappings zeggen welke directory-populatie ze bereikt. Het externe enrollment ontstaat bij de eerste keer inloggen van de verplichte gebruiker.',
      enforcingEmpty: 'Geen enkele groep legt MFA op — de verplichting zet je aan op de groep, in het tabblad Groepen.',
      enforcingError: 'De groepen die MFA opleggen konden niet worden geladen'
    }
  },
  realms: {
    title: 'Authenticatie-realms',
    createTitle: 'Realm aanmaken',
    editTitle: 'Realm bewerken',
    name: 'Realm',
    nameHint: 'Het domein dat gebruikers achter de @ typen (example.com) — ligt na het aanmaken vast',
    nameImmutableHint: 'De naam van het realm staat in elke sessie en in elke auditregel die hem ooit heeft genoemd — hernoemen zou de geschiedenis herschrijven',
    kind: 'Type',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC en SAML komen met de volgende rondes — vandaag is een realm een LDAPv3-directory',

    // Semi-wizard voor het aanmaken (ronde realm-wizard, 2026-08-03): de cards
    // met de types van stap 1 — ldap werkend, oidc/saml op de roadmap (nooit
    // een formulier zonder backend erachter).
    kindCategory: 'Type realm',
    kindSelectHint: 'Selecteer het type directory waarop dit realm gaat authenticeren.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Gebruikersnaam en wachtwoord geverifieerd met een bind op een LDAPv3-directory — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on vanuit de browser, gedelegeerd aan een OpenID Connect identity provider — komt met de volgende rondes.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Single sign-on voor de onderneming met SAML 2.0-asserties — komt met de volgende rondes.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Ingeschakeld',
    urls: 'Servers van de directory',
    urlsHint: 'Eén ldap:// of ldaps://-URL per regel (1–8), op volgorde geprobeerd — failover, nooit load balancing',
    startTls: 'StartTLS',
    verifyCertificate: 'Het certificaat verifiëren',
    cleartextWarning: 'Zonder ldaps:// of StartTLS gaat het bindwachtwoord onversleuteld over het netwerk — acceptabel in een lab, nooit in productie.',
    noVerifyWarning: 'Een niet-geverifieerde TLS-sessie authenticeert niemand: schakel de verificatie alleen uit richting een directory die je niet kunt repareren.',
    caCertificate: 'CA-certificaat (PEM)',
    caCertificateHint: 'Optionele CA-bundle die voor de TLS/StartTLS-handshake van dit realm wordt vastgezet; leeg haalt hem weg',
    caCertificatePinned: 'Vastgezet',
    connectTimeout: 'Time-out (seconden)',
    connectTimeoutHint: 'Deadline per URL voor verbinding en aanvraag (1–60); bij het verstrijken wordt de volgende URL geprobeerd',
    bindDn: 'Bind DN',
    bindDnHint: 'Het service account dat de zoekopdracht naar de gebruiker uitvoert; leeg = anonieme search bind (door AD geweigerd)',
    anonymousBind: 'Anonieme search bind',
    bindCredential: 'Bindwachtwoord (keystore)',
    bindCredentialHint: 'Een usernamePassword-item uit de keystore met het bindwachtwoord — het geheim leeft nooit op het realm',
    bindCredentialNone: 'Geen (anonieme bind)',
    bindCredentialEmpty: 'Geen enkel usernamePassword-item in de keystore — maak er een aan in Systeem > Credentials voor het bindwachtwoord.',
    baseDn: 'Base DN',
    baseDnHint: 'De subboom vanwaar de zoekopdracht naar de gebruiker vertrekt (DC=example,DC=com)',
    userFilter: 'Gebruikersfilter',
    userFilterHint: "%u wordt vervangen door het lokale deel van de login, met escaping volgens RFC 4515; niet-AD-directory's willen doorgaans (&(objectClass=inetOrgPerson)(uid=%u))",
    memberOfAttribute: 'memberOf-attribuut',
    memberOfAttributeHint: 'Eén keer gelezen, bij het inloggen — niet-gemapte groepen worden genegeerd, nesting wordt niet opgelost',
    uuidAttribute: 'UUID-attribuut',
    uuidAttributeHint: 'De onveranderlijke UUID binnen het realm (objectGUID op AD, entryUUID op OpenLDAP) — staat in de audit naast gebruiker@realm',
    displayNameAttribute: 'Attribuut voor de weergavenaam',
    displayNameAttributeHint: 'Gebruikt om de gebruiker te begroeten; ontbreekt het, dan wordt de loginnaam gebruikt',
    sudoHint: 'Schrijfacties op realms zijn sudo-beschermd: een realm is een toegangsdeur tot het platform',
    deleteBody: 'De groepsmappings van het realm gaan met hem mee; de sessies die hij heeft geauthenticeerd blijven leven tot ze verlopen — een verwijderd realm laat simpelweg niemand meer binnen.',
    tabConnection: 'Verbinding',
    tabDirectory: 'Directory',
    testTitle: 'Verbinding testen',
    testHint: 'Een sonde op de configuratie, nooit een authenticatie: hij maakt verbinding, doet de bind met het service account en — met een gebruikersnaam erbij — voert het gebruikersfilter uit.',
    testUsername: 'Gebruikersnaam (optioneel)',
    testUsernameHint: 'Een lokaal deel waarop het gebruikersfilter wordt uitgevoerd — 1 treffer is het gezonde antwoord',
    testRun: 'Test uitvoeren',
    testError: 'De sonde kon niet worden uitgevoerd',
    testReachable: 'Directory bereikbaar, servicebind geaccepteerd',
    testUnreachable: 'Directory NIET bereikbaar',
    matchedOne: 'Het gebruikersfilter heeft precies 1 item gevonden — het gezonde antwoord.',
    matchedNone: 'Het gebruikersfilter heeft geen enkel item gevonden: het filter of de base DN klopt niet.',
    matchedMany: 'Het gebruikersfilter heeft {count} items gevonden: het is niet selectief, en de logins zouden dubbelzinnig zijn (geweigerd).',
    mappingsPointer: 'Waarmee een externe groep overeenkomt is een eigenschap van de TVirt-groep (zijn realm-mappings): het punt van waarheid leeft in het tabblad Groepen.',
    mappingsPointerLink: 'Open het tabblad Groepen',
    rootHomeHint: 'De identiteiten van een extern realm leven in de root van het cluster, nooit in een vDC: rechten ken je toe waar ze nodig zijn, met delegaties — op de groep of rechtstreeks op de gebruiker, precies zoals bij de native identiteiten.'
  },
  credentials: {
    title: 'Credentials',
    createTitle: 'Credential aanmaken',
    editTitle: 'Credential bewerken',
    kind: 'Type',
    kindUsernamePassword: 'Gebruikersnaam en wachtwoord',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph-identiteit)',
    kindHintUsernamePassword: 'Ligt vast. Voor de CIFS/SMB-storages — het mountaccount waarvan de worker het geheim op het moment van mounten gebruikt.',
    kindHintIscsiChap: 'Ligt vast. Voor de iSCSI CHAP-authenticatie — gebruikersnaam = CHAP-naam, secret = CHAP-geheim.',
    kindHintNvmeDhchap: 'Ligt vast. Voor de DH-HMAC-CHAP van NVMe over Fabrics — secret = de blob DHHC-1:xx:…; de gebruikersnaam is slechts een label.',
    kindHintCephx: 'Ligt vast. Voor de Ceph-clients — gebruikersnaam = clientnaam (client.…), secret = de base64-sleutel.',
    kindImmutableHint: 'Het type ligt na het aanmaken vast — het wijzigen betekent een nieuwe credential.',
    username: 'Gebruikersnaam',
    usernameChap: 'CHAP-naam',
    usernameNvme: 'Label',
    usernameCephx: 'Clientnaam',
    usernameHint: 'Optioneel account waartoe het geheim behoort',
    usernameHintChap: 'De CHAP-naam waarmee de initiator zich authenticeert',
    usernameHintNvme: 'Niet gebruikt door het transport — een vrij label voor je eigen aantekeningen',
    usernameHintCephx: 'De naam van de cephx-client — het voorvoegsel client. wordt getolereerd',
    secret: 'Geheim',
    secretHint: 'Alleen schrijven: gebruikt door de afnemers, nooit meer getoond.',
    secretHintNvmeDhchap: 'Alleen schrijven: het DH-HMAC-CHAP-hostgeheim in de canonieke vorm DHHC-1:xx:… — gebruikt door de afnemers, nooit meer getoond.',
    secretHintCephx: 'Alleen schrijven: de base64 cephx-sleutel — gebruikt door de afnemers, nooit meer getoond.',
    secretEditHint: 'Laat leeg om het geheim niet te wijzigen — het invullen roteert het.',
    createdAt: 'Aangemaakt',
    inUseError: "Er wordt vanuit de configuratie van een storage naar '{name}' verwezen — koppel hem daar eerst los.",
    nameHint: 'Kleine letters, cijfers en koppeltekens (DNS-1123); uniek per scope',

    // Dialoog die alleen roteert (ronde #156): het geheim heeft nooit het inline potlood.
    rotateTitle: 'Geheim roteren',
    rotateHint: 'Alleen schrijven: het nieuwe geheim vervangt het opgeslagen geheim — de afnemers gebruiken het bij de volgende mount.',

    // Ronde #159 (PKI): de tabbladen Certificaten en CA.
    tabSecrets: 'Geheimen',
    tabCertificates: 'Certificaten',
    tabAuthorities: 'Certificaatautoriteiten',
    certificatesTitle: 'Certificaten',
    authoritiesTitle: 'Certificaatautoriteiten',
    caCreateTitle: 'Nieuwe CA',
    certCreateTitle: 'Nieuw certificaat',
    caMode: 'Herkomst',
    caModeGenerate: 'Genereren met TVirt',
    caModeImport: 'Importeren (sleutel + certificaat)',
    certMode: 'Herkomst',
    certModeIssue: 'Uitgeven vanaf een CA uit de keystore',
    certModeImport: 'Importeren (sleutel + certificaat)',
    issuingCa: 'Uitgevende CA',
    issuingCaHint: 'Het certificaat ontstaat in de scope van de CA, met de parent geregistreerd',
    noCasHint: 'Geen CA in de keystore — genereer of importeer er eerst een in het tabblad CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Het subject van de CA: letters, cijfers, spatie, punt, underscore, koppelteken',
    commonNameCertHint: 'OpenVPN identificeert de clients aan de CN — houd hem uniek per CA',
    days: 'Geldigheid (dagen)',
    daysCaHint: '1–7300 dagen; 3650 (10 jaar) is de standaard',
    daysCertHint: '1–3650 dagen; 365 is de standaard',
    keyType: 'Type sleutel',
    keyTypeHint: 'EC P-256 is de standaard; RSA voor legacy afnemers',
    usage: 'Gebruik',
    usageClient: 'Client (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'De extended key usage waarvoor het certificaat wordt uitgegeven',
    san: 'Alternatieve namen (SAN)',
    sanHint: "Gescheiden door komma's; letterlijke IP's worden IP:-items, de rest DNS:",
    keyPem: 'Privésleutel (PEM)',
    keyPemHint: 'Alleen schrijven: bewaard in de keystore, nooit meer getoond',
    certPem: 'Certificaat (PEM)',
    certPemHint: 'Het publieke certificaat dat bij de sleutel hoort',
    certPemCaHint: 'Het CA-certificaat dat bij de sleutel hoort (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Uitgever',
    parentCa: 'Uitgevende CA',
    parentCaImported: 'Geïmporteerd — buiten TVirt uitgegeven',
    serial: 'Serienummer',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Geldig vanaf',
    validUntil: 'Geldig tot',
    expiry: 'Vervaldatum',
    expired: 'Verlopen',
    expiresInDays: 'Verloopt over {days} d',
    revoked: 'Ingetrokken',
    revokedAtLabel: 'Ingetrokken op',
    revokeTitle: 'Certificaat intrekken',
    revokeAction: 'Intrekken',
    revokeWarning: 'Het intrekken is definitief: het serienummer komt in de CRL van de uitgevende CA en elke afnemer die ingetrokken certificaten weigert (OpenVPN voorop) wijst dit certificaat af. Un-revoke bestaat niet.',
    exportPem: 'PEM exporteren',
    exportChain: 'Ketenbundel exporteren',
    exportCrl: 'CRL exporteren',
    materialImmutableHint: 'Het X.509-materiaal ligt vast — geef opnieuw uit of importeer opnieuw',
    caInUseError: "'{name}' heeft nog levende uitgegeven certificaten (of een storage verwijst ernaar) — trek ze eerst in of verwijder ze."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: "Plaatsing, beschikbaarheid en affiniteit — waar de VM's van het cluster draaien en of ze aan moeten staan",
    loadError: 'Het Proximity-paneel heeft de store van het cluster nodig — de status van de fleet is nu niet bereikbaar',
    config: {
      title: 'Configuratie',
      subtitle: 'Plaatsingsbeleid op clusterniveau',
      save: 'Opslaan',
      saveError: 'De configuratie is geweigerd',
      strategy: 'Selectiestrategie',
      strategy_leastUsedResources: 'Minst gebruikte resources',
      strategy_leastVms: "Minste VM's",
      strategy_random: 'Willekeurig',
      strategyLeastUsedResourcesHint: "Onder de geldige kandidaten de node met het meeste resterende bruikbare RAM (waargenomen totaal − hostreservering − draaiende VM's), met de vCPU-verplichting als tiebreak. Deterministisch bij gelijke gegevens.",
      strategyLeastVmsHint: "Onder de geldige kandidaten de node met de minste draaiende VM's; gelijke standen worden op naam beslecht. Deterministisch bij gelijke gegevens.",
      strategyRandomHint: 'Uniform willekeurig onder de geldige kandidaten.',
      liveness: 'Drempel voor de levendigheid van de nodes (seconden)',
      livenessHint: "Een lid dat langer dan de drempel zwijgt is onbereikbaar: uitgesloten van de plaatsing en — als het niet in onderhoud is — dood verklaard door de HA-decider, die het fencet en zijn HA-VM's elders herstart.",
      decider: 'HA-decider',
      deciderNone: 'nog niet gekozen'
    },
    nodesTitle: 'Nodes',
    nodesSubtitle: 'Levendigheid en empirische capaciteit — bruikbaar RAM = totaal − basis − vastgelegd',
    nodeCol: 'Node',
    stateCol: 'Status',
    ramCol: 'RAM (totaal − basis − vastgelegd)',
    usableCol: 'Bruikbaar',
    vmsCol: 'Belasting',
    neverSeen: 'nooit gezien',
    freshChip: 'bereikbaar',
    staleChip: 'onbereikbaar',
    attestedChip: 'bevestigd uitgeschakeld',
    ramFormula: 'totaal − basis − vastgelegd',
    haTitle: 'Hoge beschikbaarheid',
    haSubtitle: 'VM\'s met de HA-vlag zijn "altijd aan": TVirt herstart ze na elke niet-gevraagde stop — dezelfde node met backoff, een andere node wanneer die van hen sterft (alleen bij gedeelde storage).',
    haNone: 'Nog geen enkele VM heeft de HA-vlag — schakel hem hier of in de details van de VM in.',
    haVmCol: 'Virtuele machine',
    haStateCol: 'Status',
    haRestartsCol: 'HA-herstarts',
    haLastEventCol: 'Laatste gebeurtenis',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'De HA-wijziging is geweigerd',
    rules: {
      title: 'Affiniteitsregels',
      createTitle: 'Nieuwe proximity-regel',
      editTitle: 'Regel bewerken',
      nameHint: 'Kleine letters, cijfers en koppeltekens (DNS-label)',
      vms: 'Virtuele machines',
      vmsHint: "Minstens twee VM's — de regel legt vast waar ze ten opzichte van elkaar draaien",
      type: 'Type',
      affinity: 'Affiniteit (samen)',
      antiAffinity: 'Anti-affiniteit (gescheiden)',
      typeAffinityHint: "De VM's moeten op DEZELFDE node draaien.",
      typeAntiAffinityHint: "De VM's moeten op VERSCHILLENDE nodes draaien — het klassieke HA-paar.",
      mode: 'Modus',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Schendingen weigeren de bewerking (start, migratie, failover) met een sprekende foutmelding.',
      modeSoftHint: 'Voorkeur, nooit blokkerend: een plaatsing in overtreding gaat door met een zichtbare waarschuwing.',
      satisfied: 'Plaatsing',
      satisfiedYes: 'nageleefd',
      satisfiedNo: 'geschonden',

      // Standaarddialoog (ronde #156): de schendingen hebben hun eigen regel, geen tooltip.
      violations: 'Schendingen',
      noViolations: 'Geen'
    },
    events: {
      title: 'HA-gebeurtenissen',
      subtitle: 'Het logboek van de beschikbaarheid — herstarts, fencing, failovers en de eerlijk vermelde overslagen',
      none: 'Nog niets.',
      when: 'Wanneer',
      kind: 'Gebeurtenis',
      target: 'Object',
      detail: 'Detail',
      kindRestarted: 'HA-herstart',
      kindGaveUp: 'opgegeven (crash loop)',
      kindNodeAttested: 'node gefenced',
      kindFailedOver: 'failover',
      kindNoCandidate: 'geen kandidaat',
      kindStorageLocalSkip: 'overgeslagen (lokale storage)',
      kindZombieFenced: 'zombie beëindigd'
    }
  }
}
